<template>
	<div class="bg-gray">
		<BaseNav></BaseNav>
		<router-view></router-view>
		<BaseFooter></BaseFooter>
	</div>
</template>

<script>
	import BaseNav from "@/components/BaseNavigation"
	import BaseFooter from "@/components/BaseFooter"
	export default{
		components:{
			BaseNav,
			BaseFooter
		},
		data(){
			return{
				
			}
		},
		mounted() {
			
		},
		methods:{
			
		}
	}
</script>

<style scoped>
	.bg-gray {
		background: #F6F7FC;
	}
</style>



// WEBPACK FOOTER //
// src/pages/roadshow/index.vue